import React, { useRef, useState } from "react";
import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonModal,
    IonTitle,
    IonToolbar,
    IonText,
    IonLabel,
} from "@ionic/react";
import SignaturePad, { SignaturePadHandle } from "./SignaturePad";

interface Props {
    buttonLabel: string;
    signatoryName: string;
    onSubmit: (dataUrl: string) => void;
    onModalOpening?: () => boolean;
    isReadOnly?: boolean;
}

export const SignatureModal: React.FC<Props> = ({
    buttonLabel,
    signatoryName,
    onSubmit,
    onModalOpening,
    isReadOnly,
}) => {
    const sigPadRef = useRef<SignaturePadHandle>(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleCancel = () => {
        sigPadRef.current?.clear();
        setIsOpen(false);
    };

    const handleDone = (dataUrl: string) => {
        onSubmit(dataUrl);
        setIsOpen(false);
    };

    const handleButtonClicked = () => {
        let shouldOpen = true;

        if (onModalOpening) {
            shouldOpen = onModalOpening();
        }

        if (shouldOpen) {
            setIsOpen(true);
        }
    };

    return (
        <>
            <div>
                {isReadOnly ? (
                    <p>
                        <IonLabel class="ion-text-wrap">Not Signed</IonLabel>
                    </p>
                ) : (
                    <IonButton shape="round" color="primary" size="small" onClick={handleButtonClicked}>
                        {buttonLabel}
                    </IonButton>
                )}
            </div>

            <IonModal isOpen={isOpen} onDidDismiss={handleCancel}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Signature</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={handleCancel} color="medium">
                                Cancel
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>

                <IonContent className="ion-padding">
                    <IonText color="medium">
                        <p style={{ marginTop: 0 }}>Please sign in the box below. Signature is required.</p>
                    </IonText>

                    <SignaturePad
                        ref={sigPadRef}
                        header={
                            <IonText>
                                <strong>{signatoryName}</strong>
                            </IonText>
                        }
                        onDone={handleDone}
                    />
                </IonContent>
            </IonModal>
        </>
    );
};

export default SignatureModal;
